module.exports = __webpack_public_path__ + "img/ch17_02_果茶误会.ee51f051.jpg";